import PageWrapper from 'components/utils/PageWrapper';
import autoformPlaceholder from '../images/autoform-unselected.png';
import WeightSchemaAutoform from 'pages/WeightSchema';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import AutoformContainer from 'components/autoform/AutoformContainer';

export const weightingSchemaRoutes = {
    path: '/weighting-schema',
    element: (
        <PageWrapper titleId="weight_schema_page_title">
            <WeightSchemaAutoform />
        </PageWrapper>
    ),
    children: [
        {
            index: true,
            element: <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />,
        },
        {
            path: ':itemId',
            element: <AutoformContainer />,
        },
    ],
};
